// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="m19.26.014-.276.036c-.78.101-1.59.47-2.22 1.007-.106.09-3.494 3.467-7.529 7.504-6.438 6.44-7.344 7.355-7.398 7.471a.873.873 0 0 0-.06.158c0 .014-.397 1.564-.881 3.444-.813 3.156-.88 3.434-.882 3.622 0 .181.007.218.069.33.15.276.42.43.709.407.091-.008 1.573-.377 3.573-.89 1.88-.484 3.43-.88 3.444-.88a.854.854 0 0 0 .159-.06c.116-.054 1.031-.96 7.471-7.398 4.037-4.035 7.413-7.423 7.503-7.529a4.452 4.452 0 0 0 1.014-2.22c.04-.26.04-1.03 0-1.284-.26-1.602-1.298-2.89-2.779-3.446a4.584 4.584 0 0 0-.849-.23c-.197-.033-.92-.062-1.068-.042m-.142 1.537a3.07 3.07 0 0 0-1.248.551 1.49 1.49 0 0 0-.182.153c0 .007.912.925 2.026 2.04L21.74 6.32l.068-.08c.734-.857.89-2.114.389-3.13a2.65 2.65 0 0 0-.548-.76 2.817 2.817 0 0 0-1.554-.802 3.552 3.552 0 0 0-.977.003m-3.032 2.295-.51.51L17.61 6.39l2.034 2.034.516-.516.516-.516-2.028-2.028a240.941 240.941 0 0 0-2.04-2.028c-.007 0-.242.23-.522.51m-7.038 7.038-5.46 5.46 2.034 2.034 2.034 2.034 5.46-5.46 5.46-5.46-2.034-2.034-2.034-2.034-5.46 5.46m-6.69 9.125c-.306 1.197-.554 2.18-.55 2.183.007.007 4.342-1.1 4.359-1.113.012-.01-3.218-3.247-3.239-3.247-.007 0-.263.98-.57 2.177"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const PencilBoldIcon = Icon;
export default PencilBoldIcon;
